import { render, staticRenderFns } from "./NewsCenter.vue?vue&type=template&id=2b649b76&scoped=true"
import script from "./NewsCenter.vue?vue&type=script&lang=js"
export * from "./NewsCenter.vue?vue&type=script&lang=js"
import style0 from "./NewsCenter.vue?vue&type=style&index=0&id=2b649b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b649b76",
  null
  
)

export default component.exports